import React from 'react';
import { CirclePerson2, Toast } from '../../../../brenger-shared-ui';
import { Translate } from 'react-localize-redux-dep-updated';
import { useNotification } from '../../../../hooks/useNotification';
import { useTypedSelector } from '../../../../hooks';

export const ContactNotification: React.FC = () => {
  const notification = useNotification('offer-limited-until-midnight');
  const progressStep = useTypedSelector(state => state.generalTransport.layout.step);

  React.useEffect(() => {
    if (progressStep === 6) {
      notification.add();
    } else {
      notification.remove();
    }
  }, [progressStep]);

  return (
    <Toast
      isVisible={notification.isVisible}
      prefix={<CirclePerson2 />}
      handleClose={notification.removeForOneSession}
      title={<Translate id={'request_flow.contact.notification.header'} />}
      body={<Translate id={'request_flow.contact.notification.text'} />}
    />
  );
};
